"use client";
import { useState, useEffect, useCallback } from "react";
import Image from "next/image";
import { IconButton, Link } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useSwipeable } from "react-swipeable";

import styles from "./Carousel.module.css"

const Carousel = ({ slides, autoPlayInterval = 2000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);


  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        goToNext();
      }, autoPlayInterval);
      return () => clearInterval(interval);
    }
  }, [currentIndex, isHovered]);

  // Next Slide
  const goToNext = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  }, [slides]);

  // Previous Slide
  const goToPrev = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
  }, [slides]);

  // Direct Navigation using Dots
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Swipe support for mobile
  const handlers = useSwipeable({
    onSwipedLeft: goToNext,
    onSwipedRight: goToPrev,
    trackMouse: true,
  });

  return (
    <div {...handlers} onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    className="carousel-container">
      {/* Left Navigation Button */}
      {/* <IconButton className="nav-button left" onClick={goToPrev}>
        <ArrowBackIos />
      </IconButton> */}

      {/* Slide Images */}
      <div className="carousel-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? "active" : ""}`}
          >
            <Link href={`/shop/books/${slide._id}`}>
            <Image
              src={`${process.env.NEXT_PUBLIC_IMG_URL3}${slide.image[0].baseurl}${slide.image[0].fileservername}`}
              alt={slide.title}
              layout="fill"
              objectFit="cover"
              priority={index === 0}
              loading={index === 0 ? undefined : "lazy"}
            />
            </Link>
          </div>
        ))}
      </div>

      {/* Right Navigation Button */}
      {/* <IconButton className="nav-button right" onClick={goToNext}>
        <ArrowForwardIos />
      </IconButton> */}

      {/* Dot Indicators */}
      <div className="dot-container">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? "active-dot" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>

      {/* Styles */}
      <style jsx>{`
        .carousel-container {
          position: relative;
          width: 100%;
          height: 550px;
          overflow: hidden;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 6px;

        }

        .carousel-wrapper {
          display: flex;
          width: 100%;
          height: 100%;
          transition: transform 0.8s ease-in-out;
          transform: translateX(-${currentIndex * 100}%);
        }

        .slide {
          min-width: 100%;
          height: 100%;
          position: relative;
          transition: opacity 0.8s ease-in-out;
        }

        .active {
          opacity: 1;
        }

        .nav-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
          background: rgba(0, 0, 0, 0.5);
          color: white;
          padding: 10px;
          border-radius: 50%;
        }

        .left {
          left: 10px;
        }

        .right {
          right: 10px;
        }

        .dot-container {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 10px;
        }

        .dot {
          width: 15px;
          height: 15px;
          background: #000;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          opacity: 0.5;
          transition: opacity 0.3s;
        }

        .active-dot {
          opacity: 1;
          background: #ffffff;
        }

        @media (max-width: 1199px) {
        .carousel-container {
            height: 350px;
          }
        }

        @media (max-width: 768px) {
          .carousel-container {
            height: 250px;
          }

          .nav-button {
            padding: 8px;
          }

          .dot {
            width: 10px;
            height: 10px;
          }
        }
          @media (max-width: 480px) {
          .carousel-container {
            height: 150px;
          }
          }
      `}</style>
    </div>
  );
};

export default Carousel;
